// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/776a5d79/" + chunkId + "." + __webpack_require__.h() + ".v776a5d79.js";
};